import * as React from 'react';
import { Lock } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Routes } from 'constants/pages';
import { Link } from 'react-router-dom';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
}

export const UpgradePlanCell: React.FC<Props> = (props) => {
  const { row } = props;

  switch (row.type) {
    case 'placeholder':
    case 'no-data':
    case 'alert':
      return null;
    default:
      break;
  }

  return (
    <Link to={Routes.Plans}>
      <Button
        className="text-gray-600 flex space-x-2 items-center hover:bg-gray-100"
        variant="text"
      >
        <div className="text-center p-0 shrink-0 flex items-center justify-center">
          <Lock style={{ fontSize: 18 }} />
        </div>
        <span className="underline">Upgrade your account</span>
      </Button>
    </Link>
  );
};
UpgradePlanCell.displayName = 'SmartPerDiem.Table.Cell.UpgradePlanCell';
